import { useState } from "react"
import { styled } from "styled-components"
import { useRecoilValue, useSetRecoilState } from "recoil"
import quizPhaseState from "../../recoil/quizPhase"
import quizPreinfoState from "../../recoil/quizPreinfo"
import usePreinfoPhaseConditions from "../../hooks/QuizPage/usePreinfoPhaseConditions"
import { StyledButton } from "../common/Buttons"
import MajorSelector from "./MajorSelector"
import DetailedMajorSelector from "./DetailedMajorSelector"
import { useCookies } from "react-cookie"
import { nanoid } from "nanoid"
import useScrollReset from "../../hooks/useScrollReset"
// import ModalSearch from "./ModalSearch"

const QuizPreinfo = () => {
  const [, setModalShow] = useState(false)
  const setQuizPhase = useSetRecoilState(quizPhaseState)
  const preinfo = useRecoilValue(quizPreinfoState)
  const [, setCookie] = useCookies(["quizRound", "quizSessionId"])

  // useEffect(() => {
  //   // 뒤로 가기, 다른 페이지로 이동
  //   return () => {
  //     localStorage.removeItem("quizPreinfo")
  //     console.log("???")
  //     resetPreinfo()
  //   }
  // }, [resetPreinfo])

  // useEffect(() => {
  //   // 새로 고침, 창 닫기
  //   const handleBeforeUnload = () => {
  //     localStorage.removeItem("quizPreinfo")
  //   }
  //   window.addEventListener("beforeunload", handleBeforeUnload)
  //   return () => {
  //     window.removeEventListener("beforeunload", handleBeforeUnload)
  //   }
  // }, [])

  useScrollReset()

  const goToMainPhase = () => {
    const newSessionId = nanoid()
    setCookie("quizSessionId", newSessionId)
    setCookie("quizRound", 0)
    setQuizPhase("main")
  }

  const goToIntroPhase = () => {
    setQuizPhase("intro")
  }

  const { isDetailRequired, isPreinfoAnswered } = usePreinfoPhaseConditions()

  return (
    <>
      <FlexContainer>
        <MajorSelector setModalShow={setModalShow} />
        <DetailedMajorSelector major={preinfo.major} show={isDetailRequired} />
      </FlexContainer>
      <FlexContainer>
        <StyledButton
          $size="large"
          onClick={goToMainPhase}
          disabled={!isPreinfoAnswered}
        >
          다음
        </StyledButton>
        <StyledButton $size="large" onClick={goToIntroPhase}>
          이전 단계로
        </StyledButton>
      </FlexContainer>
      {/* {modalShow && <ModalSearch setModalShow={setModalShow} />} */}
    </>
  )
}

export default QuizPreinfo

const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
`
